import { useAtom, useAtomValue } from 'jotai';
import { crmTractFormLoadableAtom } from './atoms';
import { InlineLoading, RadioButton, RadioButtonGroup } from '@carbon/react';
import style from './tract-record-type.module.scss';
import { useMemo } from 'react';
import { atomField } from 'atoms/form-atoms';

interface TractRecordTypeProps {
  tractRecordTypes: Array<{ value: string; label: string }>;
}

export const TractRecordType = ({ tractRecordTypes }: TractRecordTypeProps) => {
  const dummyAtomField = useMemo(() => {
    return atomField('' as string);
  }, []);
  const form = useAtomValue(crmTractFormLoadableAtom);

  const [recordType, setRecordType] = useAtom(
    form.state === 'hasData' ? form.data.recordType : dummyAtomField
  );

  const isLoading = form.state === 'loading';
  if (isLoading) {
    return <InlineLoading></InlineLoading>;
  }

  return (
    <div className={style.tractRecordTypeContainer}>
      <h2>Select Record Type*</h2>
      <div className={style.radioButtonGroup}>
        <RadioButtonGroup
          name="recordType"
          valueSelected={recordType.value}
          onChange={(value: string | number | undefined) => {
            setRecordType(value as string);
          }}
        >
          {tractRecordTypes?.map((option: { value: string; label: string }) => (
            <RadioButton
              key={option.value}
              value={option.value}
              labelText={option.label}
            />
          ))}
        </RadioButtonGroup>
      </div>
    </div>
  );
};
